import { Injectable } from "@angular/core";
import { WizardAbstractService } from "./wizard-abstract.service";
import { WizardStep } from "@app/core/model/wizard-step";
import { WizardIdEnum } from "@app/core/model/enum/wizard-id.enum";

@Injectable({
    providedIn: 'root'
})
export class VignetteListWizardService extends WizardAbstractService {
    constructor() {
        super();
        this.initRoute = '/offers';
        this.idWizard = WizardIdEnum.VIGNETTE_LIST_PRESENTATION;
        this.label = 'Préférences de navigations';
        this.description = 'Apprenez que vos préférences de navigation sont sauvegardées';

        const stepDiscoverVignette = WizardStep.create('discover-filter-thumbnails-btn', this)
            .withTitle(`Vos préférences sont enregistrées`)
            .withText(`Visualisez notre catalogue dans votre format préféré : <strong>en vignette`)
            .attachTo('#filter-thumbnails-btn', 'right')
            .waitForElement(2000)
            .addNextButton()
            .build();

        const stepDiscoverLigne = WizardStep.create('discover-filter-list-btn', this)
            .withTitle(`Vos préférences sont enregistrées`)
            .withText(`Visualisez notre catalogue dans votre format préféré : <strong>en liste</strong>`)
            .attachTo('#filter-list-btn', 'right')
            .waitForElement(2000)
            .addCompleteButton()
            .build();




        this.addStep(stepDiscoverVignette);
        this.addStep(stepDiscoverLigne);
    }

    override isAvailable(): boolean {
        return false;
    }
}